const STORAGE_KEY = 'conference-study:recent-searches';
const MAX_RECENT_SEARCHES = 5;

export interface RecentSearchStore {
  load(): string[];
  add(query: string): string[];
}

export function createRecentSearchStore(
  storage: Pick<Storage, 'getItem' | 'setItem'> | null = window.sessionStorage,
): RecentSearchStore {
  let memory: string[] = [];
  const load = (): string[] => {
    if (!storage) return memory;
    try {
      const value = JSON.parse(storage.getItem(STORAGE_KEY) ?? '[]') as unknown;
      return Array.isArray(value)
        ? value.filter((item): item is string => typeof item === 'string')
        : [];
    } catch {
      return [];
    }
  };
  const save = (value: string[]): void => {
    memory = value;
    try {
      storage?.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      // The in-memory state remains available when storage is restricted.
    }
  };
  return {
    load,
    add(query) {
      const normalized = query.trim();
      const value = [
        normalized,
        ...load().filter(
          (item) => item.toLocaleLowerCase() !== normalized.toLocaleLowerCase(),
        ),
      ].slice(0, MAX_RECENT_SEARCHES);
      save(value);
      return value;
    },
  };
}

